<h1 mat-dialog-title>
  {{ 'igo.context.bookmarkButton.dialog.title' | translate }}
</h1>
<div mat-dialog-content>
  <mat-form-field>
    <input
      matInput
      required
      autocomplete="off"
      maxlength="128"
      [placeholder]="
        'igo.context.bookmarkButton.dialog.placeholder' | translate
      "
      [(ngModel)]="title"
    />
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button
    mat-button
    color="primary"
    [disabled]="!title"
    (click)="dialogRef.close(title)"
  >
    {{ 'igo.common.confirmDialog.confirmBtn' | translate }}
  </button>
  <button mat-button (click)="dialogRef.close(false)">
    {{ 'igo.common.confirmDialog.cancelBtn' | translate }}
  </button>
</div>
